import { Localization } from "@viamap/viamap2-common";
import { TooltipWrapper } from "src/propertyInfoTemplates/PropertyComponents";
import { AnnotationQuality } from "./ANNTypes";

export function annotationQualityTone(quality?: AnnotationQuality): "none" | "gold" | "silver" | "bronze" {
   if (quality === AnnotationQuality.Gold) {
      return "gold";
   }
   if (quality === AnnotationQuality.Silver) {
      return "silver";
   }
   if (quality === AnnotationQuality.Bronze) {
      return "bronze";
   }
   return "none";
}

export function annotationQualityLabel(quality?: AnnotationQuality): string {
   if (quality === AnnotationQuality.Gold) {
      return Localization.getText("Gold");
   }
   if (quality === AnnotationQuality.Silver) {
      return Localization.getText("Silver");
   }
   if (quality === AnnotationQuality.Bronze) {
      return Localization.getText("Bronze");
   }
   return Localization.getText("None");
}

export function ANNQualityBadge(props: {
   quality?: AnnotationQuality;
   verified?: boolean;
   verifierInfo?: string;
   hideIfEmpty?: boolean;
}) {
   if (props.hideIfEmpty && !props.quality && !props.verified) {
      return <div className="ann-components-quality-cell-empty">-</div>;
   }
   const tone = annotationQualityTone(props.quality);
   const qualityLabel = annotationQualityLabel(props.quality);
   const statusText = props.verified
      ? (props.verifierInfo || Localization.getText("Verified"))
      : Localization.getText("Not verified");
   const statusTooltip = (
      <div className="ann-tooltip">
         <div className="ann-tooltip__title">{qualityLabel}</div>
         <div className="ann-tooltip__body">{statusText}</div>
      </div>
   );
   return (
      <div className="ann-components-quality-cell">
         <div className={`ann-quality-badge ann-quality-${tone}`}>
            <span className="ann-quality-badge__dot" aria-hidden="true" />
            <TooltipWrapper title={statusTooltip}>
               <span className={`ann-quality-badge__status ${props.verified ? "ann-quality-badge__status--verified" : "ann-quality-badge__status--unverified"}`}>
                  {props.verified ? "✓" : "–"}
               </span>
            </TooltipWrapper>
         </div>
      </div>
   );
}
